export default __webpack_public_path__ + "static/backgroundHome-7dcacee82da8ea35b67b7155dc8d7946.webp";